import { EmptyState } from '@/components/layout/empty-state';
import { GitMerge } from 'lucide-react';

// Reconciliation queue — manual review of vendor-id matches with confidence
// in the 0.65-0.85 band. The reconciler-worker auto-resolves anything ≥0.85
// and rejects anything <0.65; the band in between needs a human SAME /
// DIFFERENT decision. V2 needs a queue endpoint; for now: empty state.

export function ReconcilePage() {
  return (
    <EmptyState
      title="RECONCILIACIÓN"
      description="Cola de pares de vendor IDs con confianza ambigua que requieren decisión humana SAME / DIFFERENT."
      value="V2"
      unit="pendiente"
      hint="El reconciler auto-resuelve > 0.85 confianza y descarta < 0.65 sin intervención. Esta cola muestra el rango intermedio (10-15 pares por día típicamente). Endpoint admin pendiente."
      icon={GitMerge}
      badge="V2"
    />
  );
}
